// extracted by mini-css-extract-plugin
module.exports = {"edit":"_2jskrOSPSzWjx4qHe-cIp1"};